import React from "react";

const LightSVG: React.FunctionComponent = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
    <rect width="24" height="24" rx="12" fill="#E5E8E9" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.001 9.048 9 9V7a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2c0 .019 0 .037-.002.055A5.038 5.038 0 0 1 16.9 13c0 2.768-2.21 5-4.9 5-2.713 0-4.9-2.232-4.9-5 0-1.6.744-3.034 1.901-3.952Zm1.099-.657V7.1h3.8v1.295a4.789 4.789 0 0 0-3.8-.004Zm1.9 1.752c.284 0 .525.245.525.536v2.5c0 .312-.24.535-.525.535-.306 0-.525-.223-.525-.535v-2.5c0-.29.219-.536.525-.536Zm.7 5a.712.712 0 0 1-.7.714.698.698 0 0 1-.7-.714c0-.38.306-.714.7-.714.372 0 .7.334.7.714Z"
      fill="#1D2948"
    />
    <path
      d="M6.05 13c0-1.205.328-2.321.94-3.281a.53.53 0 0 0-.174-.737.52.52 0 0 0-.722.156A7.274 7.274 0 0 0 5 13c0 1.429.394 2.768 1.094 3.862a.507.507 0 0 0 .722.178.555.555 0 0 0 .175-.759c-.613-.937-.941-2.053-.941-3.281ZM19 13a7.291 7.291 0 0 0-1.116-3.862.52.52 0 0 0-.721-.156.53.53 0 0 0-.175.737c.612.96.962 2.076.962 3.281 0 1.228-.35 2.344-.962 3.281a.555.555 0 0 0 .175.76c.24.155.568.088.721-.18A7.175 7.175 0 0 0 19 13Z"
      fill="#1D2948"
    />
  </svg>
);

export default LightSVG;
